export const INSCRIPTION_REJECTED_STATUS_ID = 6
export const INSCRIPTION_PAID_STATUS_ID = 7
export const INSCRIPTION_COMPLETED_STATUS_ID = 5
